import { render } from "./ButtonWrap.vue?vue&type=template&id=5a8950cc&scoped=true"
import script from "./ButtonWrap.vue?vue&type=script&lang=js"
export * from "./ButtonWrap.vue?vue&type=script&lang=js"

import "./ButtonWrap.vue?vue&type=style&index=0&id=5a8950cc&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8950cc"]])

export default __exports__